/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SipCallVoipReceivedPathParameters } from 'api/actions/sip-call-voip-received/sip-call-voip-received-path-parameters';
import { SipCallVoipReceivedResponse } from 'api/actions/sip-call-voip-received/sip-call-voip-received-response';

type SipCallVoipReceivedQueryParameters = Record<string, any>;

/**
 * The path of the SipCallVoipReceived action.
 */
export const sipCallVoipReceivedActionPath = new SweetPath<keyof SipCallVoipReceivedPathParameters>(
  '/sip/call/{id}/voip-received',
  { path: '{param}' }
);

/**
 * Creates a contextualized SipCallVoipReceived actions.
 */
export default function createSipCallVoipReceivedAction(axios: AxiosInstance) {
  return function sipCallVoipReceivedAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: SipCallVoipReceivedPathParameters;
    query?: SipCallVoipReceivedQueryParameters;
  }) {
    const path = sipCallVoipReceivedActionPath.insert(parameters);

    return axios.post<SipCallVoipReceivedResponse, SipCallVoipReceivedResponse>(path, { params: query, headers });
  };
}
